import { GridAction } from '@eforall/dashboard';
import { TopicSpecialistRow } from '../topic-specialists-view.part';

export function getActions() {

	const actions: GridAction<TopicSpecialistRow>[] = [{
		label: `Explore Specialist`,
		iconClass: 'fa-regular fa-pencil',
		isEnabled: rows => !!rows.length,
		execute: async rows => { console.log(`Action clicked!`, rows) }
	},
	];

	return actions;
}